import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Competenze from "@/pages/Competenze";
import Progetti from "@/pages/Progetti";
import ProgettoDetail from "@/pages/ProgettoDetail";
import Libro from "@/pages/Libro";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function PublicLayout() {
  return (
    <>
      <Navigation />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function AdminOnly() {
  // No nav/footer for admin pages
  return <Outlet />;
}

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream text-center px-6">
      <div>
        <h1 className="font-heading text-8xl mb-4">404</h1>
        <p className="text-ink/60">Pagina non trovata.</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="bottom-right" />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/competenze" element={<Competenze />} />
              <Route path="/progetti" element={<Progetti />} />
              <Route path="/progetti/:slug" element={<ProgettoDetail />} />
              <Route path="/libro" element={<Libro />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy-policy" element={<Privacy />} />
            </Route>
            <Route element={<AdminOnly />}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
